import { I18nT } from 'types'

const CommonFunction = class CommonFunction {
  static extractS3KeyFromUrl(s3Url: string) {
    try {
      const url = new URL(s3Url)
      let s3Key = url.pathname

      // Remove the leading slash if it exists
      if (s3Key.startsWith('/')) {
        s3Key = s3Key.substring(1)
      }

      return s3Key
    } catch (error) {
      return null
    }
  }

  static getBreadcrumbTextByFolderType = (folderType: string, t: I18nT) => {
    return t(`building.folderType.${folderType}`)
  }

  static getBreadcrumbTextByChidType = (
    type: string,
    t: I18nT,
    currentBuildingType: number
  ) => {
    if (currentBuildingType !== 20) {
      return t(`building.folderType.child360.${type?.slice(-1)}`)
    }
    return t(`building.folderType.childbcp.${type?.slice(-1)}`)
  }

  static FetchTourLocationContentFromS3Link = async (s3Link: string) => {
    // is valid digitori360 s3 link
    if (s3Link.startsWith('https://digitori360')) {
      const response = await fetch(s3Link)
      const blob = await response.blob()
      const textContent = await blob.text()
      return textContent
    }
    // For non-S3 links, just return the content as is
    return s3Link
  }
}

export default CommonFunction
